// extracted by mini-css-extract-plugin
module.exports = {"container":"Music_container__2hVtM","image":"Music_image__1Rna0"};